module.exports = __webpack_public_path__ + "0e1769df6dd79ac788c9e6b6b6e2c8a1.MP3";